<template>
    <div class="progress-circle__container-with-bg">
        <div v-if="!dontShowMax" class="progress-circle__text">
            <span class="progress-circle__value">{{ this.filled }}</span>
            <span>/</span>
            <span>{{ this.max }}</span>
        </div>
        <div v-else class="progress-circle__text level-item">
            <div>+</div>
            <div class="progress-circle__value">{{ this.filled }}</div>
        </div>
        <svg
            class="progress-circle shadow"
            viewBox="0 0 106 106"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <pattern
                    id="retiredPattern"
                    patternTransform="rotate(45)"
                    x="0"
                    y="0"
                    width="1000"
                    height="6"
                    patternUnits="userSpaceOnUse"
                >
                    <rect x="0" y="4.5" width="1000" height="1.5" fill="transparent" />
                    <!-- Info: same gray as in .bankstatus-mixin() -->
                    <rect x="0" y="0" width="1000" height="4.5" fill="#d0d0d0" />
                </pattern>
                <pattern
                    id="stripedPattern"
                    patternTransform="rotate(45)"
                    x="0"
                    y="0"
                    width="1000"
                    height="6"
                    patternUnits="userSpaceOnUse"
                >
                    <rect x="0" y="5" width="1000" height="1" fill="#a4a4a4" />
                    <rect x="0" y="0" width="1000" height="5" fill="#f5f5f5" />
                </pattern>
            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="ProgressBarRetired" transform="translate(-17.000000, -17.000000)">
                    <path
                        class="progress-circle__path"
                        d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                        id="Oval-Copy"
                        stroke="url(#retiredPattern)"
                        stroke-width="16"
                        :stroke-dasharray="circleRetired"
                        fill-rule="nonzero"
                        transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                    ></path>
                </g>
                <g id="ProgressBarDashed" transform="translate(-17.000000, -17.000000)">
                    <path
                        class="progress-circle__path"
                        d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                        id="Oval-Copy"
                        stroke="url(#stripedPattern)"
                        stroke-width="16"
                        :stroke-dasharray="circleDashed"
                        fill-rule="nonzero"
                        transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                    ></path>
                </g>
                <g id="ProgressBar" transform="translate(-17.000000, -17.000000)">
                    <path
                        class="progress-circle__path"
                        d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                        id="Oval-Copy"
                        stroke="#ffffff"
                        stroke-width="16"
                        :stroke-dasharray="circle"
                        fill-rule="nonzero"
                        transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                    ></path>
                </g>
            </g>
        </svg>
        <app-icon custom-class="progress-circle-background" icon="circle-bg-2-steps" size-px="124px" />
    </div>
</template>

<script>
// took from here: https://codepen.io/nathancockerill/pen/QBGjPr

import AppIcon from '@/components/AppIcon';
export default {
    name: 'SvgCircleWithBg',
    components: { AppIcon },
    props: {
        filled: {
            type: Number,
            default: 0,
        },
        dashed: {
            type: Number,
            default: 0,
        },
        retired: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 3,
        },
        dontShowMax: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        circle() {
            return (this.filled / this.max) * 100 * Math.PI + ',9999';
        },
        circleDashed() {
            let x = this.filled + this.dashed;
            if (x > this.max) {
                x = this.max;
            }
            return (x / this.max) * 100 * Math.PI + ',9999';
        },
        circleRetired() {
            let x = this.filled + this.dashed + this.retired;
            if (x > this.max) {
                x = this.max;
            }
            return (x / this.max) * 100 * Math.PI + ',9999';
        },
    },
};
</script>
